import 'bootstrap';
import 'slick-carousel/slick/slick.js';
import 'jquery-lazy'; 
import './vendors/jquery-lazy-mb.js';

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        $.Lazy.media_breakpoints();
        $(".lazy").Lazy();

       /*$('.hero-item').slick({
          arrows: false,
          responsive: [
            {
              breakpoint: 9999,
              settings: 'unslick'
            },
            {
              breakpoint: 992,
              settings:{
                slidesToShow: 1,
                dots: true,
              }
            }
          ]
        });*/

        $('.slider-wrapper').each(function() {
		      $(this).find('.cards__slider').slick({
		        dots: false,
		        infinite: false,
		        speed: 300,
		        slidesToShow: 1,
		        centerMode: false,
		        variableWidth: true,
						responsive: [
					    {
					      breakpoint: 960,
					      settings: {
					        centerMode: true,
					      }
					    },
					  ],
		        prevArrow : $(this).find('.prev-arrow'),
		        nextArrow : $(this).find('.next-arrow')
		      });
        });



        /*$('.header__button.main-menu').click( function() {
          $(this).toggleClass('active');
          $(this).parents('header').find('.header__main-menu').slideToggle('fast');
          $('.header__second-menu').slideUp('fast');
          $('.header__search-box').slideUp('fast');
        });

         $('.header__button.second-menu').click( function() {
          $(this).toggleClass('active');
          $(this).parents('header').find('.header__second-menu').slideToggle('fast');
          $('.header__main-menu').slideUp('fast');
          $('.header__search-box').slideUp('fast');
        });*/

         $('.header__search').click( function() {
          $(this).toggleClass('active');
          $(this).parents('header').find('.header__search-box').slideToggle('fast');
          $('.header__search-box--input input').focus();
          //$('.header__main-menu').slideUp('fast');
          //$('.header__second-menu').slideUp('fast');
        });

         $('.header__hamburger-menu').click( function() {
            $(this).find('.header__hamburger-menu--icon').toggleClass('active');
            $('.mobile-menu').slideToggle();
            //$('.header__main-menu').slideUp('fast');
            //$('.header__second-menu').slideUp('fast');
            $('body').toggleClass('mobile-menu-active');
         });

         $('.header__languages').click( function() {
            $(this).find('.header__languages--box ul').slideToggle('fast');
         });

        $('.header__lang-btn').click(function(){
        $(this).toggleClass('active');
        $('.header__lang-list').slideToggle('fast');
        });

         $(document).on( 'click', function(event) {
          if (!$(event.target).closest('.header__languages').length)  {
            $(".header__languages--box ul").hide();
          }
         });

         function onResizeAndReload() {
          if($(window).width() >= 992) {
            var contentWidth = 930;
            if($(window).width() > 1200){
              contentWidth = 1170;
            }
            var spacingLeft = ($(window).width() - contentWidth) / 2;
            $(".hero__context.frontpage").css("padding-left", Math.round(spacingLeft) + "px");
            //$(".cards__slider").css("padding-left", Math.round(spacingLeft) + "px");
          }
        }

        $(".card-link").click(function() {
        	document.location = $(this).find('.read-more a').attr("href");
        });

        $(window).on('resize', function() {
          onResizeAndReload();
        });
        onResizeAndReload();
      }
    },
    'home': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
